import { render, staticRenderFns } from "./NormalTransaction.vue?vue&type=template&id=5fa6e0fb"
import script from "./NormalTransaction.vue?vue&type=script&lang=js"
export * from "./NormalTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports